export const TYPES = {
  SET_DEFAULT_HACKER_ALL: "default_hacker/SET_DEFAULT_HACKER_ALL",
};
